import { AddOutlined, PlaylistAddOutlined } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import type { ReactElement } from 'react';
import type { PageHeaderProps } from '../../../design-system';

export function referenceCreateActions({
  createLabel,
  onCreate,
  onBulkCreate,
  disabled = false,
  loading = false,
  disabledReason,
}: {
  createLabel: string;
  onCreate: () => void;
  onBulkCreate: () => void;
  disabled?: boolean;
  loading?: boolean;
  disabledReason?: string;
}): Pick<PageHeaderProps, 'primaryAction' | 'actions'> {
  const withDisabledReason = (button: ReactElement) => (
    disabled && disabledReason
      ? <Tooltip title={disabledReason}><span>{button}</span></Tooltip>
      : button
  );
  return {
    primaryAction: withDisabledReason(
      <Button variant="fill" startIcon={<AddOutlined />} onClick={onCreate} disabled={disabled} loading={loading}>
        {createLabel}
      </Button>,
    ),
    actions: withDisabledReason(
      <Button variant="weak" startIcon={<PlaylistAddOutlined />} onClick={onBulkCreate} disabled={disabled} loading={loading}>
        대량 등록
      </Button>,
    ),
  };
}
